module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/thunder-move-9491f1465adaffabd4078f1169383f34.svg";